export const idpTypeIcon: { [k: string]: string } = {
  OKTA: 'https://slack-cdn.apono.io/integrations/okta.svg',
  OKTA_SCIM: 'https://slack-cdn.apono.io/integrations/okta.svg',
  GOOGLE_OAUTH: 'https://slack-cdn.apono.io/integrations/google.svg',
  JUMPCLOUD: 'https://slack-cdn.apono.io/integrations/jumpcloud.svg',
  AZURE: 'https://slack-cdn.apono.io/integrations/azure-ad.svg',
  ONELOGIN: 'https://slack-cdn.apono.io/integrations/onelogin.svg',
};
